export default __webpack_public_path__ + "static/media/no-notifications1.2145cb91.svg";